<template>
  <div class="bg-white">
    <div class="overflow-hidden bg-white py-16 px-4 sm:px-6 lg:px-8">
      <div class="mx-auto max-w-max lg:max-w-7xl">
        <div class="relative mb-8 md:mb-2 md:px-2">
          <div class="max-w-prose text-base lg:max-w-none">
            <h2 class="font-semibold leading-6 text-teal-600">
              Roadmap
            </h2>
            <p class="mt-2 text-3xl font-bold leading-8 tracking-tight text-gray-900 sm:text-4xl">
              Daran arbeiten wir als Nächstes
            </p>
          </div>
        </div>
        <div class="relative max-w-3xl">
          <div class="relative md:bg-white md:p-6">
            <RoadmapList :items="roadmap" />
          </div>
        </div>
      </div>
    </div>
    <div class="overflow-hidden bg-white py-8 px-4 sm:px-6 lg:px-8">
      <div class="mx-auto max-w-max lg:max-w-7xl">
        <div class="bg-gray-50 rounded-lg">
          <div class="mx-auto max-w-7xl py-12 px-4 sm:px-6 lg:flex lg:items-center lg:justify-between lg:py-16 lg:px-8">
            <h2 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
              <span class="block">
                Wachse mit unserem Podcast-Hacks Newsletter!
              </span>
              <span class="block text-teal-600">
                Jeden Dienstag in deinem Postfach.
              </span>
            </h2>
            <div class="mt-8 flex lg:mt-0 lg:flex-shrink-0">
              <div class="inline-flex rounded-md shadow">
                <a href="/newsletter" target="_blank" class="inline-flex items-center justify-center rounded-md border border-transparent bg-teal-600 px-5 py-3 text-base font-medium text-white hover:bg-teal-700">Kostenlos abonnieren</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="overflow-hidden bg-white py-16 px-4 sm:px-6 lg:px-8">
      <div class="mx-auto max-w-max lg:max-w-7xl">
        <div class="relative mb-8 md:mb-2 md:px-2">
          <div class="max-w-prose text-base lg:max-w-none">
            <h2 class="font-semibold leading-6 text-teal-600">
              Changelog
            </h2>
            <p class="mt-2 text-3xl font-bold leading-8 tracking-tight text-gray-900 sm:text-4xl">
              Zuletzt zum Studio hinzugefügt
            </p>
          </div>
        </div>
        <div class="relative max-w-3xl">
          <div class="relative md:bg-white md:p-2">
            <ChangelogList :items="changelog" />
          </div>
        </div>
      </div>
    </div>
    <div class="overflow-hidden bg-white py-16 px-4 sm:px-6 lg:px-8">
      <div class="mx-auto max-w-max lg:max-w-7xl">
        <div class="bg-gray-50 rounded-lg">
          <div class="mx-auto max-w-7xl py-12 px-4 sm:px-6 lg:flex lg:items-center lg:justify-between lg:py-16 lg:px-8">
            <h2 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
              <span class="block">Fehler gefunden oder Idee für Ausbaustufe?</span>
              <span class="block text-teal-600">Teile dein Feedback jetzt mit uns.</span>
            </h2>
            <div class="mt-8 flex lg:mt-0 lg:flex-shrink-0">
              <div class="ml-3 inline-flex rounded-md shadow">
                <a href="/help" target="_blank" class="inline-flex items-center justify-center rounded-md border border-transparent bg-white px-5 py-3 text-base font-medium text-teal-600 hover:bg-teal-50">Ticket einreichen</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useFetchResources } from '@/client/actions';

const targetRoadmap = computed(() => '/api/roadmap');
const targetChangelog = computed(() => '/api/changelog');

const actionRoadmap = useFetchResources(targetRoadmap);
const actionChangelog = useFetchResources(targetChangelog);

const { results: roadmap, fetch: fetchRoadmap} = actionRoadmap;
const { results: changelog, fetch: fetchChangelog} = actionChangelog;

const mounted = onMounted(() => {
  fetchRoadmap();
  fetchChangelog();
});
</script>